module.exports = __webpack_public_path__ + "static/media/JC.9a364fd2.svg";